"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.delay = undefined;

var _pagination = require("@alicd/next/lib/pagination");

var _pagination2 = _interopRequireDefault(_pagination);

var _icon = require("@alicd/next/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _grid = require("@alicd/next/lib/grid");

var _grid2 = _interopRequireDefault(_grid);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _cruiTable = require("@alicd/crui-table");

var _cruiTable2 = _interopRequireDefault(_cruiTable);

var _Column = require("./Column");

var _Column2 = _interopRequireDefault(_Column);

var _ColumnGroup = require("./ColumnGroup");

var _ColumnGroup2 = _interopRequireDefault(_ColumnGroup);

var _Toolbar = require("./Toolbar");

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _ToolbarBatch = require("./ToolbarBatch");

var _ToolbarBatch2 = _interopRequireDefault(_ToolbarBatch);

var _Sticky = require("./Sticky");

var _Sticky2 = _interopRequireDefault(_Sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;


function defaultFormatter(dataSource, paging) {
    if (Array.isArray(dataSource)) {
        return {
            dataSource: dataSource.slice((paging.current - 1) * paging.pageSize, paging.current * paging.pageSize),
            total: dataSource.length
        };
    }
    if (Array.isArray(dataSource.items) && dataSource.paging) {
        return {
            dataSource: dataSource.items,
            total: dataSource.paging.total
        };
    } else {
        return {
            dataSource: dataSource.data.resultList,
            total: dataSource.data.total
        };
    }
}

function getDataState(props, paging) {
    if (!props.dataSource) {
        return { dataSource: [], total: 0 };
    }
    var ret = props.formatter.call(this, props.dataSource, paging);
    // if (Array.isArray(ret)) {
    //     return { dataSource: ret[0], total: ret[1] };
    // } else {
    return ret;
    // }
}

function hasClassInSet(classList, set) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(classList.values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var className = _step.value;

            if (set.has(className)) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return false;
}

var delay = exports.delay = function delay() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return new _promise2.default(function (resolve, reject) {
        return setTimeout(function () {
            return resolve();
        }, n);
    });
};

var TableArea = function (_React$Component) {
    (0, _inherits3.default)(TableArea, _React$Component);

    function TableArea(props) {
        (0, _classCallCheck3.default)(this, TableArea);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TableArea.__proto__ || (0, _getPrototypeOf2.default)(TableArea)).call(this, props));

        _this.state = (0, _assign2.default)({
            paging: _this.props.paging || _this.props.defaultPaging,
            spreaded: false,
            spreadKey: null
        });

        _this.spreadProps = null;
        _this.spreadedRowArgs = null;
        _this.clickedOnSpread = false;

        _this._safeClickNode = [];

        _this.handleCurrentPageChange = _this.handleCurrentPageChange.bind(_this);
        _this.handlePageSizeChange = _this.handlePageSizeChange.bind(_this);

        _this.renderSpreadCell = _this.renderSpreadCell.bind(_this);
        _this.spreadCellOnClick = _this.spreadCellOnClick.bind(_this);
        _this.getRowHighlighted = _this.getRowHighlighted.bind(_this);
        _this.onCloseSpread = _this.onCloseSpread.bind(_this);
        _this.clickToCloseSpread = _this.clickToCloseSpread.bind(_this);
        _this.onClickSpread = _this.onClickSpread.bind(_this);

        _this.tableStickyHeaderWithToolbar = _this.tableStickyHeaderWithToolbar.bind(_this);

        _this.getRefTable = _this.getRefTable.bind(_this);
        _this.getRefStickyPlaceholderTop = _this.getRefStickyPlaceholderTop.bind(_this);
        _this.getRefStickyPlaceholderBottom = _this.getRefStickyPlaceholderBottom.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(TableArea, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.paging != this.props.paging || nextProps.paging && (nextProps.paging.current != this.state.paging.current || nextProps.paging.pageSize != this.state.paging.pageSize || nextProps.paging.props != this.state.paging.props)) {
                this.setState({
                    paging: {
                        current: nextProps.paging.current,
                        pageSize: nextProps.paging.pageSize,
                        props: nextProps.paging.props
                    }
                });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.spreaded ^ prevState.spreaded) {
                var body = document.getElementsByTagName("body")[0];
                if (this.state.spreaded) {
                    body.addEventListener("click", this.clickToCloseSpread);
                } else {
                    body.removeEventListener("click", this.clickToCloseSpread);
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.state.spreaded) {
                var body = document.getElementsByTagName("body")[0];
                if (body) {
                    body.removeEventListener("click", this.clickToCloseSpread);
                }
            }
        }
    }, {
        key: "setStateAsync",
        value: function setStateAsync(updater) {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.setState(updater, function () {
                    return resolve();
                });
            });
        }
    }, {
        key: "getRefTable",
        value: function getRefTable() {
            return this.refs.table;
        }
    }, {
        key: "getRefStickyPlaceholderTop",
        value: function getRefStickyPlaceholderTop() {
            return this.refs.stickyPlaceholderTop;
        }
    }, {
        key: "getRefStickyPlaceholderBottom",
        value: function getRefStickyPlaceholderBottom() {
            return this.refs.stickyPlaceholderBottom;
        }
    }, {
        key: "stickyHeaderEnabled",
        value: function stickyHeaderEnabled() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return typeof this.props.stickyHeaderViewport == "number" || typeof this.props.stickyHeaderViewport == "function";
        }
    }, {
        key: "getToolbarSticky",
        value: function getToolbarSticky() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            if (props.stickyToolbar) {
                return props.stickyHeaderViewport;
            } else {
                return undefined;
            }
        }
    }, {
        key: "tableStickyHeader",
        value: function tableStickyHeader() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            if (!props.stickyToolbar) {
                return props.stickyHeaderViewport;
            } else {
                return this.tableStickyHeaderWithToolbar;
            }
        }
    }, {
        key: "tableStickyHeaderWithToolbar",
        value: function tableStickyHeaderWithToolbar(x, y) {
            var h = ReactDOM.findDOMNode(this.refs.toolbars).getBoundingClientRect().height;
            var ret = this.props.stickyHeaderViewport(x - h, y - h);
            if (typeof ret == "number") {
                return ret + h;
            } else {
                return ret;
            }
        }
    }, {
        key: "handleCurrentPageChange",
        value: function handleCurrentPageChange(current) {
            var newPaging = (0, _extends3.default)({}, this.state.paging, { current: current });
            this.setState({ paging: newPaging });
            if (typeof this.props.onPagingChange == "function") {
                this.props.onPagingChange(newPaging, "pageChange");
            }
        }
    }, {
        key: "handlePageSizeChange",
        value: function handlePageSizeChange(pageSize) {
            var newPaging = (0, _extends3.default)({}, this.state.paging, { pageSize: pageSize, current: 1 });
            this.setState({ paging: newPaging });
            if (typeof this.props.onPagingChange == "function") {
                this.props.onPagingChange(newPaging, "pageSizeChange");
            }
        }
    }, {
        key: "_getSafeNode",
        value: function _getSafeNode(safeNode) {
            if (typeof safeNode === 'function') {
                safeNode = safeNode(this.props);
            }
            if (typeof safeNode === 'string') {
                safeNode = document.getElementById(safeNode);
            } else {
                try {
                    safeNode = ReactDOM.findDOMNode(safeNode);
                } catch (e) {/* regardless of error */}
            }

            return safeNode;
        }
    }, {
        key: "initSafeNode",
        value: function initSafeNode() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var safeNode = props.safeNode;

            this.addNodeForSafeClick(Array.isArray(safeNode) ? safeNode : [safeNode]);
        }
    }, {
        key: "addNodeForSafeClick",
        value: function addNodeForSafeClick(node) {
            if (Array.isArray(node)) {
                node.forEach(this.addNodeForSafeClick.bind(this));
            } else {
                var safeNode = this._getSafeNode(node);
                if (safeNode && this._safeClickNode.indexOf(safeNode) === -1) {
                    this._safeClickNode.push(safeNode);
                }
            }
        }
    }, {
        key: "clickToCloseSpread",
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
                var NO_CLOSE_CLASSES_SET, element, i, node;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                NO_CLOSE_CLASSES_SET = new _set2.default(["next-select-menu", "next-date-picker-panel", "next-range-picker-panel", "next-month-picker-panel", "next-year-picker-panel", "next-time-picker-panel-wrapper", "next-cascader-select-dropdown", "next-tree-select-dropdown", "next-cn-address-overlay", "next-cn-address-multi-overlay"]);


                                this.initSafeNode();
                                element = e.target;
                                i = 0;

                            case 4:
                                if (!(i < this._safeClickNode.length)) {
                                    _context.next = 11;
                                    break;
                                }

                                node = this._safeClickNode[i];

                                if (!(node.contains(element) || node === element || !document.documentElement.contains(element))) {
                                    _context.next = 8;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 8:
                                i++;
                                _context.next = 4;
                                break;

                            case 11:
                                if (!element) {
                                    _context.next = 19;
                                    break;
                                }

                                if (!element.classList.contains("cn-tablearea-spread-donot-close")) {
                                    _context.next = 14;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 14:
                                if (!(element.classList.contains("next-overlay-inner") && hasClassInSet(element.classList, NO_CLOSE_CLASSES_SET))) {
                                    _context.next = 16;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 16:

                                element = element.parentElement;
                                _context.next = 11;
                                break;

                            case 19:
                                if (this.clickedOnSpread) {
                                    this.clickedOnSpread = false;
                                    // return;
                                }
                                return _context.abrupt("return", this.onCloseSpread());

                            case 21:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function clickToCloseSpread(_x6) {
                return _ref.apply(this, arguments);
            }

            return clickToCloseSpread;
        }()
    }, {
        key: "onClickSpread",
        value: function onClickSpread() {
            this.clickedOnSpread = true;
        }
    }, {
        key: "renderSpreadCell",
        value: function renderSpreadCell(value, index, record) {
            var renderRaw = typeof this.spreadProps.cell == "function" ? this.spreadProps.cell : function (v) {
                return v;
            };
            return _react2.default.createElement(
                "a",
                { href: "javascript:;" },
                renderRaw(value, index, record)
            );
        }
    }, {
        key: "spreadCellOnClick",
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(value, index, record) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!this.spreadProps.spreadParams || this.spreadProps.spreadParams.shake === undefined || this.spreadProps.spreadParams.shake)) {
                                    _context2.next = 5;
                                    break;
                                }

                                _context2.next = 3;
                                return this.onCloseSpread();

                            case 3:
                                _context2.next = 5;
                                return delay(64);

                            case 5:
                                this.spreadedRowArgs = { value: value, index: index, record: record };
                                if (typeof this.spreadProps.onClick == "function") {
                                    this.spreadProps.onClick.call(null, value, index, record);
                                }
                                _context2.next = 9;
                                return this.setState({
                                    spreaded: true,
                                    spreadKey: record[this.props.primaryKey]
                                });

                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function spreadCellOnClick(_x7, _x8, _x9) {
                return _ref2.apply(this, arguments);
            }

            return spreadCellOnClick;
        }()
    }, {
        key: "onCloseSpread",
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                return _context3.abrupt("return", this.setStateAsync({ spreaded: false, spreadKey: null }));

                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function onCloseSpread() {
                return _ref3.apply(this, arguments);
            }

            return onCloseSpread;
        }()
    }, {
        key: "getRowHighlighted",
        value: function getRowHighlighted(record, index) {
            var resultProp = typeof this.props.getRowHighlighted == "function" ? this.props.getRowHighlighted.call(null, record, index) : false;
            if (this.state.spreaded && this.state.spreadKey == record[this.props.primaryKey]) {
                return true;
            }
            return resultProp;
        }
    }, {
        key: "recurseTableChildren",
        value: function recurseTableChildren(child, i) {
            var _this3 = this;

            switch (child.type) {
                case _Column2.default:
                    var _child$props = child.props,
                        spread = _child$props.spread,
                        spreadParams = _child$props.spreadParams,
                        spreadTitle = _child$props.spreadTitle,
                        rest = (0, _objectWithoutProperties3.default)(_child$props, ["spread", "spreadParams", "spreadTitle"]);

                    var spreadPropsOverride = {};
                    if (spread) {
                        this.spreadProps = child.props;
                        (0, _assign2.default)(spreadPropsOverride, {
                            onClick: this.spreadCellOnClick,
                            cell: this.renderSpreadCell
                        });
                    }
                    return {
                        element: _react2.default.createElement(_cruiTable2.default.Column, (0, _extends3.default)({ key: i }, rest, spreadPropsOverride)),
                        colCount: ++i
                    };
                case _ColumnGroup2.default:
                    {
                        var children = _react2.default.Children.map(child.children, function (child) {
                            var _recurseTableChildren = _this3.recurseTableChildren(child),
                                element = _recurseTableChildren.element,
                                colCount = _recurseTableChildren.colCount;

                            i = colCount;
                            return element;
                        });
                        return {
                            element: _react2.default.createElement(
                                _cruiTable2.default.ColumnGroup,
                                (0, _extends3.default)({ key: i }, child.props),
                                children
                            ),
                            colCount: ++i
                        };
                    }
                default:
                    console.error("The children of <TableArea /> must be <TableArea.Column> or <TableArea.ColumnGroup>");
            }
        }
    }, {
        key: "renderSpread",
        value: function renderSpread() {
            if (this.spreadProps) {
                var _spread = this.spreadProps.spread;
                var spreadStyle = {};
                var spreadWrapStyle = {};
                if ((typeof _spread === "undefined" ? "undefined" : (0, _typeof3.default)(_spread)) == "object") {
                    _spread = function spread() {
                        return _spread;
                    };
                }
                var spreadParams = this.spreadProps.spreadParams;

                var title = "";
                if (this.state.spreaded) {
                    var titleProp = undefined;
                    if (spreadParams && typeof spreadParams.title != "undefined") {
                        titleProp = spreadParams.title;
                    } else if (typeof this.spreadProps.spreadTitle != "undefined") {
                        titleProp = this.spreadProps.spreadTitle;
                    }
                    if (typeof titleProp == "function") {
                        title = titleProp.call(null, this.spreadedRowArgs.value, this.spreadedRowArgs.index, this.spreadedRowArgs.record);
                    } else if (typeof titleProp != "undefined") {
                        title = titleProp;
                    }
                }

                if ((typeof spreadParams === "undefined" ? "undefined" : (0, _typeof3.default)(spreadParams)) == "object") {
                    var width = spreadParams.width,
                        marginTop = spreadParams.marginTop,
                        _title = spreadParams.title,
                        shake = spreadParams.shake,
                        spreadStyleCustom = (0, _objectWithoutProperties3.default)(spreadParams, ["width", "marginTop", "title", "shake"]);

                    (0, _assign2.default)(spreadStyle, spreadStyleCustom);
                    width && (spreadWrapStyle.width = width);
                    marginTop && (spreadWrapStyle.top = spreadWrapStyle.paddingBottom = marginTop);
                }

                return _react2.default.createElement(
                    "div",
                    {
                        className: (0, _classnames2.default)("cn-tablearea-spread-wrap", "cn-tablearea-spread-donot-close", this.state.spreaded ? "cn-tablearea-spread-show" : "cn-tablearea-spread-hide"),
                        style: spreadWrapStyle
                    },
                    _react2.default.createElement(
                        "div",
                        {
                            className: "cn-tablearea-spread",
                            onClick: this.onClickSpread,
                            style: spreadStyle
                        },
                        _react2.default.createElement(
                            Row,
                            { className: "cn-tablearea-spread-header" },
                            _react2.default.createElement(
                                Col,
                                null,
                                _react2.default.createElement(
                                    "div",
                                    { className: "cn-tablearea-spread-title" },
                                    title
                                )
                            ),
                            _react2.default.createElement(
                                Col,
                                { fixedSpan: 4, className: "cn-tablearea-spread-closecol" },
                                _react2.default.createElement(_icon2.default, {
                                    onClick: this.onCloseSpread,
                                    type: "close",
                                    className: "cn-tablearea-spread-close"
                                })
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "cn-tablearea-spread-content" },
                            this.spreadedRowArgs ? _spread(this.spreadedRowArgs.value, this.spreadedRowArgs.index, this.spreadedRowArgs.record) : null
                        )
                    )
                );
            }
            return null;
        }
    }, {
        key: "hasRowSelection",
        value: function hasRowSelection() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.rowSelection && (0, _typeof3.default)(props.rowSelection) == "object";
        }
    }, {
        key: "renderSelectStat",
        value: function renderSelectStat(dataState) {
            var _props = this.props,
                locale = _props.locale,
                hasStats = _props.hasStats,
                rowSelection = _props.rowSelection;

            if (this.hasRowSelection() && hasStats !== false) {

                if (!rowSelection.selectedRowKeys) {
                    console.warn("CNTableArea: rowSelection must has selectedRowKeys when hasStats is not false!");
                    return null;
                }
                return _react2.default.createElement(
                    "span",
                    { className: "cn-tablearea-stat" },
                    locale.stat(rowSelection.selectedRowKeys.length || "0", dataState.total).props.children
                );
            } else if (hasStats === true) {
                return _react2.default.createElement(
                    "span",
                    { className: "cn-tablearea-stat" },
                    locale.statNoSelection(dataState.total).props.children
                );
            }
            return null;
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                className = _props2.className,
                style = _props2.style,
                paging = _props2.paging,
                defaultPaging = _props2.defaultPaging,
                onPagingChange = _props2.onPagingChange,
                dataSource = _props2.dataSource,
                formatter = _props2.formatter,
                getRowHighlighted = _props2.getRowHighlighted,
                primaryKey = _props2.primaryKey,
                hasMinorPaging = _props2.hasMinorPaging,
                locale = _props2.locale,
                pageSizeList = _props2.pageSizeList,
                pageShowCount = _props2.pageShowCount,
                stickyHeaderViewport = _props2.stickyHeaderViewport,
                stickyPaginationViewport = _props2.stickyPaginationViewport,
                stickyToolbar = _props2.stickyToolbar,
                hasStats = _props2.hasStats,
                rest = (0, _objectWithoutProperties3.default)(_props2, ["className", "style", "paging", "defaultPaging", "onPagingChange", "dataSource", "formatter", "getRowHighlighted", "primaryKey", "hasMinorPaging", "locale", "pageSizeList", "pageShowCount", "stickyHeaderViewport", "stickyPaginationViewport", "stickyToolbar", "hasStats"]);


            var dataState = getDataState(this.props, this.state.paging);

            var toolbarBatch = null;
            var toolbarMain = null;
            var tableChildren = [];
            var columnCount = 0;

            this.spreadProps = null;
            _react2.default.Children.forEach(this.props.children, function (child) {
                switch (child.type) {
                    case _Toolbar2.default:
                        toolbarMain = child.props.children;break;
                    case _ToolbarBatch2.default:
                        toolbarBatch = child.props.children;break;
                    case _Column2.default:
                    case _ColumnGroup2.default:
                        {
                            // TODO: respect the original key prop
                            var _recurseTableChildren2 = _this4.recurseTableChildren(child, columnCount),
                                element = _recurseTableChildren2.element,
                                colCount = _recurseTableChildren2.colCount;

                            tableChildren.push(element);
                            columnCount = colCount;
                            break;
                        }
                    default:
                        break;
                }
            });

            return _react2.default.createElement(
                "div",
                { className: (0, _classnames2.default)("cn-tablearea", className), style: style },
                _react2.default.createElement(_Sticky.Placeholder, { ref: "stickyPlaceholderTop" }),
                _react2.default.createElement(
                    _Sticky2.default,
                    {
                        direction: "top",
                        placeholder: this.getRefStickyPlaceholderTop,
                        value: this.getToolbarSticky(),
                        otherWaypoint: this.getRefTable
                    },
                    _react2.default.createElement(
                        "div",
                        { className: "cn-tablearea-top", ref: "toolbars" },
                        _react2.default.createElement(
                            "div",
                            { className: "cn-tablearea-topright" },
                            toolbarMain,
                            hasMinorPaging ? _react2.default.createElement(_pagination2.default, (0, _extends3.default)({
                                className: "cn-tablearea-spg",
                                size: "small",
                                shape: "arrow-only",
                                type: "simple",
                                current: this.state.paging.current,
                                pageSize: this.state.paging.pageSize,
                                total: dataState.total,
                                onChange: this.handleCurrentPageChange,
                                onPageSizeChange: this.handlePageSizeChange,
                                locale: locale
                            }, this.state.paging.props)) : null
                        ),
                        this.renderSelectStat(dataState),
                        toolbarBatch
                    )
                ),
                _react2.default.createElement(
                    _cruiTable2.default,
                    (0, _extends3.default)({
                        ref: "table",
                        dataSource: dataState.dataSource,
                        getRowHighlighted: this.getRowHighlighted,
                        primaryKey: this.props.primaryKey,
                        locale: locale,
                        stickyHeaderViewport: this.stickyHeaderEnabled() ? this.tableStickyHeader() : null
                    }, rest),
                    tableChildren
                ),
                _react2.default.createElement(
                    _Sticky2.default,
                    {
                        direction: "bottom",
                        placeholder: this.getRefStickyPlaceholderBottom,
                        value: stickyPaginationViewport,
                        otherWaypoint: this.getRefTable
                    },
                    _react2.default.createElement(_pagination2.default, (0, _extends3.default)({
                        className: "cn-tablearea-bottom",
                        current: this.state.paging.current,
                        pageSize: this.state.paging.pageSize,
                        total: dataState.total,
                        onChange: this.handleCurrentPageChange,
                        onPageSizeChange: this.handlePageSizeChange,
                        pageSizeSelector: "dropdown",
                        pageSizePosition: "start",
                        locale: locale,
                        pageSizeList: pageSizeList,
                        pageShowCount: pageShowCount
                    }, this.state.paging.props))
                ),
                _react2.default.createElement(_Sticky.Placeholder, { ref: "stickyPlaceholderBottom" }),
                this.renderSpread()
            );
        }
    }]);
    return TableArea;
}(_react2.default.Component);

TableArea.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    paging: _propTypes2.default.object,
    defaultPaging: _propTypes2.default.object,
    onPagingChange: _propTypes2.default.func,
    dataSource: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    formatter: _propTypes2.default.func,
    isZebra: _propTypes2.default.bool,
    getRowHighlighted: _propTypes2.default.func,
    primaryKey: _propTypes2.default.string,
    hasMinorPaging: _propTypes2.default.bool,
    pageSizeList: _propTypes2.default.arrayOf(_propTypes2.default.number),
    pageShowCount: _propTypes2.default.number,
    safeNode: _propTypes2.default.any,
    stickyHeaderViewport: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
    stickyPaginationViewport: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
    stickyToolbar: _propTypes2.default.bool,
    hasStats: _propTypes2.default.bool
};
TableArea.defaultProps = {
    defaultPaging: { current: 1, pageSize: 10 },
    formatter: defaultFormatter,
    isZebra: true,
    primaryKey: "id",
    hasMinorPaging: true,
    stickyToolbar: true
};
exports.default = TableArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/TableArea.js
// module id = 706
// module chunks = 0